<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="card">
      <div class="is-centered card-header">
        <div
          :class="`${info.color}`"
          class="column has-text-centered is-size-5 card-header-title"
        >
          {{ info.title }}
        </div>
      </div>
      <div class="is-centered card-content">
        <div class="columns has-text-centered">
          <div class="has-margin-auto pa-8">
            <img height="300" width="300" :src="info.image" />
            <div
              :class="`${info.color}`"
              class="has-text-centered is-size-7 has-text-weight-bold"
              v-text="info.maintext"
            ></div>
            <div
              class="has-text-centered has-text-grey is-size-7"
              v-text="info.subtext"
            ></div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="column has-text-right pa-1">
          <button
            class="button has-text-white is-employer"
            @click="$emit('submit')"
            v-text="$t('Continue')"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      required: true
    }
  }
}
</script>
